export default __webpack_public_path__ + "img/cgvKdTyK.9291e956.svg";